<template>
  <v-card
    rounded="sm"
    outlined
    depressed
  >
    <v-card-title class="custom_gray font-weight-600 text-black">
      Gabarito
    </v-card-title>
    <v-divider class="m-0" />

    <v-card-text class="p-2 pb-4 text-black">
      <v-container
        v-for="(module,key) in challengeModules"
        :key="key"
        fluid
      >
        <v-row>
          <v-col>
            <div
              v-if="module.block_id"
              class="small"
            >
              <p
                class="m-0 font-weight-600"
                style="font-size:13px"
              >
                {{ module.block.trail.name }} 
              </p>
              <p class="m-0">
                {{ module.module_name }}
              </p>
            </div>
            <div
              v-else
              class="small"
            >
              <p
                class="m-0 font-weight-600"
                style="font-size:13px"
              >
                {{ module.subject_name }}
              </p>
              <p class="m-0">
                {{ module.module_name }}
              </p>
            </div>
          </v-col>
        </v-row>
        <v-row class="mb-2 justify-content-start border border-deep-dark rounded-sm">
          <v-col
            v-for="(question) in module.questions"
            :key="question.key"
            cols="2"
            class="d-flex justify-content-center"
            :class="{
              'px-1' : isMobile
            }"
          >
            <v-tooltip
              v-if="question.invalidated"
              top
            >
              <template #activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                >
                  <MarkerComponentItem
                    :question="question"
                    :challenge="challenge"
                    :is-active="activeTab == question.key"
                    @click="$emit('input', question.key)"
                  />
                </div>
              </template>
              <span>Essa questão foi anulada.</span>
            </v-tooltip>
            <MarkerComponentItem
              v-else
              :question="question"
              :challenge="challenge"
              :is-active="activeTab == question.key"
              @click="$emit('input',question.key)"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import MarkerComponentItem from "./MarkerComponentItem"
import { mapGetters } from "vuex";
export default {
  name: 'MarkerComponent',
  components:{
    MarkerComponentItem,
  },
  props: {
    challenge: {
      type: Object,
      required: true,
    },
    activeTab: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['challengeModules']),
  }
}
</script>

